import * as React from 'react';

import { Button, ButtonProps } from '@built/design-system';
import * as styles from './ActionButton.module.scss';

export default function ActionButton(props: ActionButtonProps) {
  const { disabled, loading } = props;

  const classes = [styles.root];
  if (props.className) {
    classes.push(props.className);
  }

  return (
    <Button
      size="lg"
      shadow={true}
      {...props}
      disabled={disabled || loading}
      className={classes.join(' ')}
    />
  );
}

export interface ActionButtonProps extends ButtonProps {}



// WEBPACK FOOTER //
// ./src/components/ActionButton.tsx